import { memo } from 'react'
import { Path, Svg } from 'react-native-svg'

interface SvgIconProps {
  color?: string
  size?: number
}

export const SvgStar = memo(({ color = '#7750D4', size = 24 }: SvgIconProps) => (
  <Svg width={size} height={size} viewBox="0 0 11 11" fill="none">
    <Path
      d="M9.47548 8.45666C9.29016 9.01996 8.82109 9.45738 8.24624 9.60296L6.37149 10.0777L4.4983 10.5601C3.92392 10.708 3.33054 10.5419 2.94329 10.1248L1.68037 8.76456L0.411565 7.40982C0.0225127 6.99442 -0.101793 6.39091 0.0858103 5.82825L0.697635 3.99326L1.30202 2.1562C1.48735 1.5929 1.95642 1.15549 2.53127 1.00991L4.40602 0.535137L6.27921 0.0528054C6.85359 -0.0950918 7.44696 0.0710101 7.83421 0.488092L9.09714 1.8483L10.3659 3.20304C10.755 3.61844 10.8793 4.22196 10.6917 4.78462L10.0799 6.6196L9.47548 8.45666Z"
      fill={color}
    />
  </Svg>
))

SvgStar.displayName = 'SvgStar'
